import angular from 'angular';

import { ItemView as NetworksItemView } from '@/react/docker/networks/ItemView';
import { r2a } from '@/react-tools/react2angular';
import { withCurrentUser } from '@/react-tools/withCurrentUser';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { DashboardView } from '@/react/docker/DashboardView/DashboardView';
import { ListView } from '@/react/docker/events/ListView';
import { PoliciesView } from '@/react/docker/policies/PoliciesView';

import { containersModule } from './containers';
import { tasksModule } from './tasks';
import { servicesModule } from './services';
import { configsModule } from './configs';
import { imagesModule } from './images';
import { stacksModule } from './stacks';

export const viewsModule = angular
  .module('portainer.docker.react.views', [
    containersModule,
    tasksModule,
    servicesModule,
    configsModule,
    imagesModule,
    stacksModule,
  ])
  .component(
    'dockerDashboardView',
    r2a(withUIRouter(withCurrentUser(DashboardView)), [])
  )
  .component(
    'dockerPoliciesView',
    r2a(withUIRouter(withCurrentUser(PoliciesView)), [])
  )
  .component('eventsListView', r2a(withUIRouter(withCurrentUser(ListView)), []))
  .component(
    'networkDetailsView',
    r2a(withUIRouter(withCurrentUser(NetworksItemView)), [])
  ).name;
